export var HANDICAP = 1;
export var MATCH_HANDICAP = 2;
export var TWO_WAY = 3;
export var TOTAL = 4;
export var MATCH_RESULTS_MINUTES = 5;
export var THREE_WAY = 6;
export var CONDITIONAL_THREE_WAY = 7;
export var MORE_THAN_X_GOALS = 8;
export var EUROPEAN_HANDICAP = 9;
export var CORRECT_SCORE = 10;
export var FOUR_WAY = 11;
export var CORRECT_VALUE = 12;
export var MATCH_WIN_METHOD = 13;
export var TIME_MATCH = 14;
export var VICTORY_AND_TOTAL = 15;
export var FIRST_GOAL_MINUTES = 16;
export var TENNIS_CORRECT_SCORE_WITH_CONDITION = 17;
export var MINIMATCH_TOTAL = 18;
export var TWO_WAY_BY_TEAM = 19;
export var BASKETBALL_MATCH_WIN_WITH_DIFFERENCE_BY_TEAM = 20;
export var BASKETBALL_MATCH_WIN_WITH_DIFFERENCE = 21;
export var BASKETBALL_QUARTER_WIN_WITH_DIFFERENCE = 22;
export var VOLLEYBALL_SET_WIN_WITH_DIFFERENCE_BY_TEAM = 23;
export var VOLLEYBALL_SET_WIN_WITH_DIFFERENCE = 24;
export var BOX_MATCH_WIN = 25;
export var ASIAN_HANDICAP = 26;
export var TOTAL_AND_BOTH_TO_SCORE = 27;
export var MATCH_RESULTS_DOUBLE_CHANCE = 28;
export var FOUR_COLUMN = 29;
export var TENNIS_GAME_WINNER = 30;
export var WHO_HIGHER = 31;



// WEBPACK FOOTER //
// ./src/constants/SlotFamilyType.js